import { render } from "./StudentEventDetailsPage.vue?vue&type=template&id=0935108f&ts=true"
import script from "./StudentEventDetailsPage.vue?vue&type=script&lang=ts"
export * from "./StudentEventDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__